import { useEffect, useState } from 'react';
import axios from '../axios';
import API from '../actions/api';

/**
 * Custom hook to fetch financial accounts that belong to the 'asset' category group.
 * This dynamically fetches from the API instead of using hardcoded values.
 * 
 * @returns {Object} { assetAccounts, loading, error }
 */
export const useAssetFinancialAccounts = () => {
  const [assetAccounts, setAssetAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAssetAccounts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API}/financial_category/`, {
          params: { acc_cat_group: 'asset' },
        });
        setAssetAccounts(response.data || []);
        setError(null);
      } catch (err) {
        console.error('Error fetching asset accounts:', err);
        setError(err.message || 'Failed to fetch asset accounts');
        setAssetAccounts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAssetAccounts();
  }, []);

  return {
    assetAccounts,
    loading,
    error,
  };
};

export default useAssetFinancialAccounts;

